module.exports = __webpack_public_path__ + "img/minus-icon.5ab58fc9.svg";